import axios from "axios";
import { useAuthStore } from "../stores/authStore";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});

api.interceptors.request.use((config) => {
  const auth = useAuthStore();
  if (auth.token) {
    config.headers.Authorization = auth.token;
  }
  return config;
});

export default api;

export function getPost(id) {
  return api.get(`/v2/posts/${id}`);
}

export function getPostsPage(page) {
  return api.get(`/v2/posts?page=${page}`);
}

export function getFeedPage(page) {
  return api.get(`/v2/posts?feed=True&page=${page}`);
}

export function getPostsProfile(user_id) {
  return api.get(`/v2/posts?user=${user_id}`);
}

export function putLike(post_id) {
  return api.post(`/v2/posts/${post_id}/like`);
}

export function putDislike(post_id) {
  return api.post(`/v2/posts/${post_id}/dislike`);
}

export function getComments(post_id) {
  return api.get(`/v2/comments?post=${post_id}`);
}

export function addComment(post, text) {
  return api.post("/v2/comments", { post, text });
}

export function deleteComment(comment_id) {
  return api.delete(`/v2/comments/${comment_id}`);
}

export function addComplainAboutComment(comment_id, data) {
  return api.post(`/v2/comments/${comment_id}/complain`, data);
}

export function getCategoryComplain() {
  return api.get(`/complain/category`);
}

export function getUser(user_id) {
  return api.get(`/account/user/${user_id}`);
}

export function searchUser(data) {
  return api.get(`/account/user?search=${data}`);
}

export function searchUserByUsername(username) {
  return api.get(`/account/user?autocomplete=${username}`);
}

export function followUser(user_id) {
  return api.post(`/account/user/${user_id}/follow`);
}

export function unfollowUser(user_id) {
  return api.post(`/account/user/${user_id}/unfollow`);
}

export function Login(data) {
  return api.post(`/account/login`, data);
}

export function GetCode(data) {
  return api.post(`/account/get_code`, data);
}

export function GetRecommendations() {
  return api.get(`/account/user/recommended`);
}

export function blockUserRecommendations(user_id, data) {
  return api.patch(`/account/user/${user_id}`, data);
}

export function putProfile(data) {
  return api.put("/account/profile", data);
}
